// The location bar under the panel's header, on a brand with several locations (D4). Wording from the Amigo design's
// copy sheet (Location bar).
export default {
  label: 'Établissement',
  all_one: 'Tous les {{count}} établissements',
  all_other: 'Tous les {{count}} établissements',
};
